import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef, useEffect } from 'react';
import { IconWrapper } from './Icon.styles';
import { useForwardedRef } from '../hooks';
/**
 * Description for Icon
 */

export var Icon = forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      size = _ref.size,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["icon", "size", "title"]);

  var IconComponent = icon;
  var safeRef = useForwardedRef(ref);
  useEffect(function () {
    if (safeRef.current && title && safeRef.current.firstElementChild) {
      // inject a title attribute to the SVG for accessibility and test purposes
      safeRef.current.firstElementChild.setAttribute('title', title);
    }
  }, [safeRef, title]);
  return /*#__PURE__*/React.createElement(IconWrapper, Object.assign({
    ref: safeRef,
    iconSize: size,
    role: "img"
  }, props), /*#__PURE__*/React.createElement(IconComponent, null));
});